import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=b4c5b2f2&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=b4c5b2f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5b2f2",
  null
  
)

export default component.exports